'use strict';

const h = require('phy');

const EnrollmentIframe = () => {
  return h('iframe', {
    id: 'select-enrollment-iframe',
    scrolling: 'no',
    sandbox: 'allow-forms allow-popups allow-same-origin allow-scripts',
    title: 'Select Enrollment Popup',
    frameBorder: 0,
  });
};

module.exports = EnrollmentIframe;
